export default __webpack_public_path__ + "static/media/marker.845122c8.svg";